/* eslint-disable react/forbid-elements */
import {
  Button,
  LinkButton,
  H1,
  LinearGradient,
  Paragraph,
  Section,
  useMedia,
  XStack,
  YStack,
} from '@bounty/creators-design-system'
import { ImageRolls } from '../../../components/ImageRoll/ImageRoll'
import {
  MOBILE_NAV_HEIGHT,
  NAV_HEIGHT,
} from '../../../components/web/WebConstants'
import { FeaturedIn } from './FeaturedIn'
import { useBrandSignUpModal } from './SignUpModal'

export const Hero = () => {
  const { gtMd, gtSm } = useMedia()
  const [, setOpen] = useBrandSignUpModal()
  return (
    <YStack
      mt={-MOBILE_NAV_HEIGHT}
      pt={MOBILE_NAV_HEIGHT}
      $gtMd={{ mt: -NAV_HEIGHT, pt: NAV_HEIGHT }}
      backgroundColor={'rgba(92, 225, 230, 1)'}
      width="100%"
      alignItems="center"
      pb="$6"
    >
      {/* Removing this because it makes the background purple
      <LinearGradient
        position="absolute"
        top={0}
        bottom={0}
        left={0}
        right={0}
        colors={['#3A3BC5', '#484AF4']}
        locations={[0.26, 0.68]}
        start={{ x: 1.048977006733651, y: 0.5612865944226898 }}
        end={{ x: -0.04897700673365102, y: 0.4387134055773102 }}
      />*/}
      <Section
        position="relative"
        overflow="hidden"
        containerSize="md"
        pb="$8"
        mb="$10"
        $gtSm={{
          flexDirection: 'row',
        }}
        $gtMd={{
          flexDirection: 'row',
          width: '100%',
          height: 600,
          mx: 0,
          pb: 0,
          alignItems: 'center',
        }}
        $gtLg={{
          flexDirection: 'row',
          width: '100%',
          // height: 373,
          mx: 0,
          pb: 0,
        }}
      >
        <YStack
          px="$4"
          py="$7"
          $gtMd={{ paddingTop: 103, paddingLeft: 71, paddingRight: 101 }}
          $gtLg={{ flexBasis: 0, flex: 1 }}
          flexShrink={1}
        >
          <H1
            size="$2xl"
            width="100%"
            $gtMd={{ size: '$4xl', width: '100%', mb: '$6' }}
            zIndex={5}
            color="rgb(56, 56, 57)"
            mb="$1"
          >
            Put UGC and partnerships on autopilot for your Shopify store.
          </H1>
          <Paragraph
            size="$sm"
            $gtMd={{ size: '$xl', width: '100%', mb: '$10' }}
            color="rgb(56, 56, 57)"
            width="100%"
            mb="$4"
          >
            Save time. Save money. Automate your content pipeline with
            pay-for-performance creator marketing.
          </Paragraph>
          <XStack space="$3">
            <LinkButton
              event={'Brands Hero Get Started Clicked'}
              variant="ghost"
              backgroundColor="$neutral.50"
              color="rgb(56, 56, 57)"
              size="$lg"
              href="https://5jmb9.share.hsforms.com/2iaN_A4CKSk6S7z8RIyDHYA"
              target="_blank"
            >
              Schedule a Demo
            </LinkButton>
            {/* <Button
              variant="outline"
              colorScheme="whiteAlpha"
              borderColor={'rgb(56, 56, 57)'}
              buttonTextProps={{ color: 'rgb(56, 56, 57)' }}
            >
              Watch Intro
            </Button> */}
          </XStack>
        </YStack>
        <YStack
          width={400}
          borderWidth={4}
          borderColor="$primary.300"
          borderRadius={'$8'}
          overflow="hidden"
          height={370}
          position="relative"
          right={-50}
          bottom={-25}
          alignSelf="flex-end"
          transform={[{ rotate: '3.12deg' }]}
          flexShrink={0}
          $gtSm={{
            width: 550,
            right: -60,
          }}
          $gtMd={{
            top: 0,
            right: -40,
            height: 450,
            width: 650,
            alignSelf: 'center',
            flexShrink: 0,
          }}
          $gtLg={{
            width: 550,
            flexBasis: 0,
            flex: 1,
            flexShrink: 0,
            right: 0,
          }}
        >
          <YStack position="relative" left={-40}>
            <ImageRolls
              width={gtMd ? 550 : gtSm ? 550 : 400}
              height={gtMd ? 450 : gtSm ? 450 : 370}
              overflowMultiplier={1.25}
              numberOfColumns={3}
            />
          </YStack>
        </YStack>
      </Section>
      <FeaturedIn />
    </YStack>
  )
}
